import Handlebars from 'handlebars';

import reviewsTemplate from '../template/reviewsTemplate.hbs';
import reviewData from '../data/reviews.json';

const swiperWrapper = document.querySelector('.reviews__swiper-wrapper');
const navigationElement = document.querySelector('.reviews__controller');
const paginationElement = document.querySelector('.reviews__swiper-pagination');

const LINKEDIN_LINK =
  'https://www.linkedin.com/in/viktoriia-recruiter/details/recommendations/?detailScreenTabIndex=0';

const screenWidth = window.innerWidth;

// Need to hide navigation and pagination when few slides for desktop
if (reviewData.length < 5 && screenWidth > 1279.9) {
  navigationElement.classList.add('is-hidden');
  paginationElement.classList.add('is-hidden');
}

const prepareData = data => {
  return data.reverse().map(item => ({
    ...item,
    linkedinLink: item.isLinkedInLink ? LINKEDIN_LINK : null,
    safeLink: item.isLinkedInLink
      ? `<a
          href="${LINKEDIN_LINK}"
          class="reviews__link"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Read more in LinkedIn"
         >
           read more
         </a>`
      : '',
  }));
};

const generateReviewsSlides = data => {
  const template = Handlebars.compile(reviewsTemplate);
  const html = template({ reviews: prepareData(data) });
  swiperWrapper.innerHTML = html;
};

generateReviewsSlides(reviewData);
